import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { getExchange, resetList as reset, setFilters, setPagination } from 'exchange/actions';

import { getPagination, getFilters, getNeedFetch } from 'exchange/selectors';
import { getCompany } from 'auth/selectors';

import { valueFromEvent } from 'lib/util';

class ExchangeListHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };
  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'origin', name: 'moneda origen', search: true },
      { key: 'final', name: 'moneda destino', search: true },
      { key: 'date', name: 'fecha', search: true },
      { key: 'value', name: 'valor', search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };

  fetch = (filters, pagination) =>
    this.props.fetch(
      this.props.company.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 200);

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillUnmount = () => this.props.reset();

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.needFetch && !isEqual(nextProps.pagination, this.props.pagination)) {
      this.fetch(nextProps.filters, nextProps.pagination);
    } else if (nextProps.needFetch && !isEqual(nextProps.filters, this.props.filters)) {
      this.fetchDebounced(nextProps.filters, nextProps.pagination);
    }
  };

  render = () =>
    this.props.render({
      handleOrderChange: this.handleOrderChange,
      handleLimitChange: this.handleLimitChange,
      handlePageChange: this.handlePageChange,
      handleFiltersChange: this.handleFiltersChange,
      handleSubmit: this.handleSubmit,
      handleToggleSearch: this.handleToggleSearch,
      columnSearch: this.state.columnSearch,
    });
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { fetch: getExchange, reset, setFilters, setPagination };

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeListHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/containers/ExchangeListHandlers.js